import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { hotTopics } from '@/mocks/data';

export default function HotTopics() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const amount = 320;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -amount : amount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="py-10 md:py-14 px-4 md:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              今日<span className="text-accent-600">热搜</span>追踪
            </h2>
            <p className="mt-1 text-sm text-foreground-600">实时追踪全网最热吃瓜事件</p>
          </div>
          <span className="hidden md:inline-block px-4 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-semibold whitespace-nowrap">
            🔥 实时热度
          </span>
        </div>

        <div className="relative">
          <button
            onClick={() => scroll('left')}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-50 flex items-center justify-center text-foreground-700 hover:text-foreground-900 transition-colors cursor-pointer -ml-3 md:-ml-5 hidden md:flex shadow-sm"
          >
            <i className="ri-arrow-left-s-line text-lg"></i>
          </button>
          <button
            onClick={() => scroll('right')}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-50 flex items-center justify-center text-foreground-700 hover:text-foreground-900 transition-colors cursor-pointer -mr-3 md:-mr-5 hidden md:flex shadow-sm"
          >
            <i className="ri-arrow-right-s-line text-lg"></i>
          </button>

          <div
            ref={scrollRef}
            className="flex gap-4 overflow-x-auto scrollbar-hide pb-2 -mx-4 px-4 md:mx-0 md:px-0"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {hotTopics.map((topic) => (
              <Link
                key={topic.id}
                to={`/article/${topic.id}`}
                className="flex-shrink-0 w-[260px] md:w-[280px] group cursor-pointer"
              >
                <div className="bg-background-50 rounded-2xl overflow-hidden transition-transform duration-300 group-hover:scale-[1.02]">
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={topic.image}
                      alt={topic.title}
                      title={topic.title}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-4">
                    <div className="flex items-start justify-between gap-2">
                      <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed flex-1">
                        {topic.title}
                      </p>
                      <span className="text-lg font-heading font-bold text-accent-600 whitespace-nowrap flex-shrink-0">
                        {topic.heat >= 10000 ? `${(topic.heat / 10000).toFixed(1)}万` : topic.heat}
                      </span>
                    </div>
                    <span className="inline-block mt-2 px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs whitespace-nowrap">
                      {topic.category}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}